import { SFOwnerFieldType } from "@/types/salesforce/fields";


export const display_owner = (owner: SFOwnerFieldType | null, long = false, _default = "") => {
    if (owner) {
        if (owner.first_name && owner.last_name) {
            if (long) {
                return `${owner.first_name} ${owner.last_name}`;
            } else {
                return `${owner.first_name[0]}. ${owner.last_name}`;
            }
        } else if (owner.email) {
            if (long) {
                return owner.email;
            } else {
                return owner.email.split("@")[0];
            }
        }
    }
    return _default;
};

export const display_user = (user: { first_name: string | null, last_name: string | null, email: string | null } | null, long = false, _default = "") => {
    if (user) {
        if (user.first_name && user.last_name) {
            if (long) {
                return `${user.first_name} ${user.last_name}`;
            } else {
                return `${user.first_name[0]}. ${user.last_name}`;
            }
        } else if (user.email) {
            if (long) {
                return user.email;
            } else {
                return user.email.split("@")[0];
            }
        }
    }
    return _default;
};
